import { Icon, Link as LinkAsButton } from 'anf-core-react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import styles from './menu.module.scss';

/**
 * The button positioned in the header of the menu to go back to the previous menu level.
 *
 * @param {Object} props - The props for the Menu component.
 * @param {string} [label] - The text of the button.
 * @param {Function} props.handleClick - Function triggered when the button is clicked.
 * @returns {JSX.Element} The back button component.
 *
 * */
const MenuBackButton = ({ handleClick, label }) => (
  <LinkAsButton classList={classNames(styles.link, styles.back)} onClick={handleClick}>
    <div className={styles.label}>
      <div className={styles.icon}>
        <Icon
          icon="left-thin"
          label=""
          size="xs"
        />
      </div>
      <div>{label}</div>
    </div>
  </LinkAsButton>
);

MenuBackButton.propTypes = {
  handleClick: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
};

export default MenuBackButton;
